<div >
    <div class="upload-v2">
        <img style="width: 40px; height: 40px;" appDragDrop (files)="onChangeBanner($event)" [hidden]="banners?.length" (click)="banner.click()" src="./assets/images/campaign-v2/upload-button.png">
        <input hidden #banner type="file" (change)="onChangeBanner($event.target.files)" (click)="$event.target.value=null">
        <div [hidden]="!banners?.length" class="update-success">
            <div class="img-success" [ngStyle]="{'background-image': 'url(' + banners[0]?.src + ')'}"></div>
            <img (click)="onRemoveImage()" class="remove-banner" src="./assets/images/campaign-v2/icon-remove-button.png">
        </div>
    </div>
</div>